export const styles = {
  container: (theme) => ({
    display: "flex",
    flexDirection: "column",
  }),
  img: (theme) => ({}),
  body: (theme) => ({
    display: "flex",
    justifyContent: "space-between",
    flexWrap: { xs: "wrap", md: "no-wrap" },
  }),
};
